require('./iban');

module.exports = 'Iban';



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/iban/index.js
 ** module id = 108
 ** module chunks = 1
 **/